import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { OrderService } from '../../core/services/order';
import * as orderActions from '../actions/orders.action';

@Injectable()
export class OrderEffects {
  private actions$ = inject(Actions);

  private orderService = inject(OrderService);

  loadOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(orderActions.LOAD_ORDERS),
      switchMap(() =>
        this.orderService.getOrders().pipe(
          map((orders) => new orderActions.LoadOrdersSuccess(orders)),
          catchError((error) => of(new orderActions.LoadOrdersFail(error))),
        ),
      ),
    ),
  );

  loadOrdersV2$ = createEffect(() =>
    this.actions$.pipe(
      ofType(orderActions.LOAD_ORDERSV2),
      switchMap(() =>
        this.orderService.getOrders().pipe(
          map((orders) => new orderActions.LoadOrdersV2Success(orders)),
          catchError((error) => of(new orderActions.LoadOrdersFail(error))),
        ),
      ),
    ),
  );

  loadOpenOrdersTotalNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(orderActions.LOAD_TOTAL_OPEN_ORDERS),
      switchMap(() =>
        this.orderService.getOpenOrdersTotal().pipe(
          map((total) => new orderActions.LoadTotalOpenOrdersSuccess(total)),
          catchError((error) =>
            of(new orderActions.LoadTotalOpenOrdersFail(error)),
          ),
        ),
      ),
    ),
  );
}
